import { usePageMeta } from "@/hooks/usePageMeta";
import { SITE } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Mail, MessageCircle, MapPin, Clock } from "lucide-react";

const DELIVERY = "https://images.unsplash.com/photo-1588083402307-ad42a3870779?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Contact() {
  usePageMeta("Contact Us", "Get in touch with Nicee via email or WhatsApp.");
  const waHref = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent("Hi Nicee!")}`;

  return (
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <h1 className="font-heading text-3xl font-bold text-ink sm:text-4xl">Get in touch</h1>
        <p className="mt-2 text-ink-soft">Questions about your order or our products? We're here to help.</p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div className="space-y-4">
          <a href={`mailto:${SITE.email}`} className="flex items-center gap-4 rounded-2xl border border-border/60 bg-white p-6 shadow-ambient transition-transform duration-300 hover:-translate-y-1" data-testid="contact-email">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand/10 text-brand"><Mail className="h-6 w-6" /></span>
            <div>
              <p className="font-semibold text-ink">Email us</p>
              <p className="text-sm text-ink-soft">{SITE.email}</p>
            </div>
          </a>
          <a href={waHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 rounded-2xl border border-border/60 bg-white p-6 shadow-ambient transition-transform duration-300 hover:-translate-y-1" data-testid="contact-whatsapp">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366]/15 text-[#1a9e4b]"><MessageCircle className="h-6 w-6" /></span>
            <div>
              <p className="font-semibold text-ink">WhatsApp</p>
              <p className="text-sm text-ink-soft">{SITE.whatsappDisplay}</p>
            </div>
          </a>
          <div className="flex items-center gap-4 rounded-2xl border border-border/60 bg-white p-6 shadow-ambient">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sage/15 text-sage"><Clock className="h-6 w-6" /></span>
            <div>
              <p className="font-semibold text-ink">Delivery hours</p>
              <p className="text-sm text-ink-soft">Every day · 7:00 AM – 8:00 PM</p>
            </div>
          </div>
          <div className="flex items-center gap-4 rounded-2xl border border-border/60 bg-white p-6 shadow-ambient">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand/10 text-brand"><MapPin className="h-6 w-6" /></span>
            <div>
              <p className="font-semibold text-ink">Service area</p>
              <p className="text-sm text-ink-soft">Local doorstep delivery across selected areas</p>
            </div>
          </div>
          <a href={waHref} target="_blank" rel="noopener noreferrer">
            <Button className="w-full rounded-full bg-[#25D366] text-white hover:bg-[#1fb457]">
              <MessageCircle className="mr-2 h-4 w-4" /> Chat on WhatsApp
            </Button>
          </a>
        </div>

        <div className="overflow-hidden rounded-[2rem] border border-border/60 shadow-ambient">
          <img src={DELIVERY} alt="Fresh groceries delivery" className="h-full min-h-[300px] w-full object-cover" />
        </div>
      </div>
    </div>
  );
}
